import React, { Component } from 'react'
import Typography from '@material-ui/core/Typography'
import TimelineItem from './TimelineItem'
import { getPatientSnapshot } from '../../api'
import { aggregateEntries } from '../../utils'
import { withStyles } from '@material-ui/core/styles'
import moment from 'moment-timezone'
import { DEFAULT_TIMEZONE } from '../../constants'

const styles = {
  timeline: {
    paddingLeft: 65
  },
  header: {
    fontSize: '1.5rem',
    padding: '15px 0'
  }
}

class Timeline extends Component {
  constructor (props) {
    super(props)

    this.state = {}
  }

  componentDidMount () {
    this.setFetchingInterval()
  }

  setFetchingInterval = (date = this.props.date) => {
    const { patient, refetch } = this.props
    getPatientSnapshot(this.props.patient.id, [moment.tz(date, DEFAULT_TIMEZONE)]).then(response => {
      this.setState({snapshot: response[0]})
    })

    if (refetch) {
      this.interval = window.setInterval(() => {
        getPatientSnapshot(patient.id, [date]).then(response => {
          this.setState({snapshot: response[0]})
        })
      }, 60000)
    }
  }

  componentWillReceiveProps (newProps) {
    const { date } = newProps
    this.interval && window.clearInterval(this.interval)
    this.setFetchingInterval(date)
  }

  componentWillUnmount () {
    this.interval && window.clearInterval(this.interval)
  }

  notificationsForDate () {
    const { notifications } = this.props.patient
    const forDate = notifications.filter(notification => {
      return moment.tz(this.props.date, DEFAULT_TIMEZONE).isSame(notification.time, 'date') || moment.tz(this.props.date, DEFAULT_TIMEZONE).isSame(notification.end, 'date')
    })
    return forDate
  }

  render () {
    const { classes, displaySummary } = this.props
    const { snapshot } = this.state
    if (!snapshot) return <div/>
    const aggregatedEntries = aggregateEntries(snapshot, true, this.notificationsForDate(), this.props.date)

    return (
      <div>
        {
          displaySummary && (
            <div>
              <Typography className={classes.header}>Daily Snapshot</Typography>
            </div>
          )
        }
        {
          aggregatedEntries.map((entry, i) => {
            return <TimelineItem info={entry} key={entry.id} last={i === aggregatedEntries.length - 1}/>
          })
        }
      </div>
    )
  }
}

export default withStyles(styles)(Timeline)



// WEBPACK FOOTER //
// ./src/components/Timeline/Timeline.js